import React from 'react';
import { Tooltip } from 'antd';
import Icon from '@mdi/react';
import { mdiSearchWeb, mdiEarth, mdiLinkVariant } from '@mdi/js';

const JourneyChannelsFormater = ({ channel, iconProps }) => {
  if (!channel) return null;

  const networkKey = channel.toLowerCase();

  const mdiChannels = {
    seo: { title: 'SEO', icon: mdiSearchWeb },
    organic: { title: 'Custom URLs', icon: mdiEarth },
    referrer: { title: 'Referrer', icon: mdiLinkVariant },
  };

  const isMdi = mdiChannels[networkKey];
  const title = isMdi
    ? mdiChannels[networkKey].title
    : networkKey === 'facebook'
    ? 'Meta'
    : networkKey.charAt(0).toUpperCase() + networkKey.slice(1);

  return (
    <Tooltip
      placement='top'
      title={title}
      destroyTooltipOnHide
      mouseEnterDelay={0.1}
      className='cursor-pointer'
    >
      <span className='flex items-center justify-center w-4 h-4'>
        {isMdi ? (
          <Icon path={mdiChannels[networkKey].icon} size={0.8} {...iconProps} />
        ) : (
          <img src={`/icons/networks/${networkKey}.svg`} alt={networkKey} className='w-4 h-4' />
        )}
      </span>
    </Tooltip>
  );
};

export default JourneyChannelsFormater;
